import { ServiceIdSchema } from "@core/domains/identity";
import { StageSchema } from "@core/foundation/stage";
import { z } from "@core/zod";

export const ServiceClaimsSchema = z.object(
  {
    exp: z.number(),
    iat: z.number(),
    service: ServiceIdSchema,
    stage: StageSchema,
    type: z.literal("service"),
    version: z.literal(1),
  },
  {
    exp: "When the token expires, in seconds since the Unix epoch.",
    iat: "When the token was issued, in seconds since the Unix epoch.",
    service: "The id of the service that signed the token.",
    stage: "The stage the token was issued in.",
    type: "The token's kind, always service.",
    version: "The version of the claims' shape.",
  },
);

export interface ServiceClaims extends z.infer<typeof ServiceClaimsSchema> {}
